import { generalSections } from './generalSections';

export const generalManual = {
  id: 'mod-general',
  title: 'Inicio y acceso',
  isVisible: () => true,
  intro:
    'Pantallas comunes: login, panel y navegación. Incluye «Grilla de productos e ítems» y las fichas «Grilla — fila …» con cada input y select por tipo de documento (requerimiento, OC, OS compras, venta producto/servicio, guías). Cada función usa la plantilla de 12 apartados.',
  sections: generalSections,
};
